import { render, staticRenderFns } from "./CompanyDistrictDetail.vue?vue&type=template&id=f9cd4832&"
import script from "./CompanyDistrictDetail.vue?vue&type=script&lang=ts&"
export * from "./CompanyDistrictDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports